import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../permission/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const routeurl: string = state.url;
    return this.isUserLoggedIn(routeurl);
  }

  isUserLoggedIn(routeurl: string): boolean {
    if (!this.authService.isUserLoggedIn()) {
      // navigate to login page
      this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl: routeurl } // Note: mock login doesn't use returnUrl yet
      });
      return false; // Prevent route activation
    }
    return true; // User is authenticated, allow route activation
  }
}
